import { httpApi } from '@api/http.api.ts';
import type { TASK_STATUS } from '@routes/sidebar/___shared___/components/pathway-menu/constants.ts';
import type { EvaluationMethod } from '@routes/sidebar/___shared___/types.ts';
import type { AssessorTaskAction } from '@routes/sidebar/admin-center/assessor/___shared___/types.ts';
import type {
    UserPathwayTaskAnswer,
    UserPathwayTaskDetailsResponse,
} from '@routes/sidebar/learning/___pages___/learning-overview/api/task.api.ts';

export type AssessorTaskStatus = (typeof TASK_STATUS)[keyof typeof TASK_STATUS];

export interface AssessorTaskWriteRequest {
    action: AssessorTaskAction;
    answers: UserPathwayTaskAnswer[] | null;
    comments: string | null;
    evaluationMethod: EvaluationMethod | null;
    assessorId: number | null;
}

export type AssessorTaskDetailsResponse = UserPathwayTaskDetailsResponse;

const ASSESSOR_TASKS_BASE_URL = 'admin-center/assessors/user-pathways';

export const getApiAssessorTask = (
    userPathwayId: number,
    pathwayItemId: number,
): Promise<AssessorTaskDetailsResponse> =>
    httpApi
        .get<AssessorTaskDetailsResponse>(`${ASSESSOR_TASKS_BASE_URL}/${userPathwayId}/tasks/${pathwayItemId}`)
        .then(({ data }) => data);

export const putApiAssessorTask = (
    userPathwayId: number,
    pathwayItemId: number,
    payload: AssessorTaskWriteRequest,
): Promise<AssessorTaskDetailsResponse> =>
    httpApi
        .put<AssessorTaskDetailsResponse>(`${ASSESSOR_TASKS_BASE_URL}/${userPathwayId}/tasks/${pathwayItemId}`, payload)
        .then(({ data }) => data);
